<template>

    <v-card color="#f4f4f4" width="100%" class="pa-0 mt-1 -asu-form" elevation="0" :style="cssProps">
        <v-card-title class="px-0">{{ editing ? 'Edição de ASU' : 'Adição de ASU' }}</v-card-title>
        <v-card-text class="px-0">
            <v-expansion-panels class="--custom-panels" v-model="panel" :disabled="false">
                <v-expansion-panel>
                    <v-expansion-panel-header>
                        <div>
                            <div class="mx-n6 pb-3" :style="panel === 0 ? 'margin-top: -16px' : 'margin-top: -16px'"
                                style="width: calc(100% + 72px); border-radius: 4px 4px 0 0; overflow: hidden">

                                <v-progress-linear :value="models.info.percent"
                                    :color="models.info.percent == 100 ? 'success' : 'orange'"></v-progress-linear>
                            </div>
                            <div class="d-flex justify-space-between pr-3" :class="panel === 0 ? 'pt-3' : 'pt-0'">
                                <strong class="primary--text">Informações</strong>
                                <v-chip small :color="models.info.percent == 100 ? 'success' : 'orange'"><strong
                                        class="mr-1">{{ models.info.ok }}</strong> de <strong class="ml-1">{{
                                        models.info.total }}</strong></v-chip>
                            </div>
                        </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>

                        <AsuInfo :snap="form" :show-hint="showHint" :stores="stores" v-if="panel === 0"
                            @update-model="updateMod('info', $event)" @update-form="updateForm($event, 'info')"></AsuInfo>
                    </v-expansion-panel-content>
                </v-expansion-panel>
                <v-expansion-panel>
                    <v-expansion-panel-header>
                        <div>
                            <div class="mx-n6 pb-3" :style="panel === 1 ? 'margin-top: -16px' : 'margin-top: -16px'"
                                style="width: calc(100% + 72px); border-radius: 4px 4px 0 0; overflow: hidden">

                                <v-progress-linear :value="models.policy.percent"
                                    :color="models.policy.percent == 100 ? 'success' : 'orange'"></v-progress-linear>
                            </div>
                            <div class="d-flex justify-space-between pr-3" :class="panel === 1 ? 'pt-3' : 'pt-0'">
                                <strong class="primary--text">Política de compra</strong>
                                <v-chip small :color="models.policy.percent == 100 ? 'success' : 'orange'"><strong
                                        class="mr-1">{{ models.policy.ok }}</strong> de <strong class="ml-1">{{
                                        models.policy.total }}</strong></v-chip>
                            </div>
                        </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <AsuPolicy v-if="panel === 1" :snap="form" :show-hint="showHint" :stores="stores"
                            @update-model="updateMod('policy', $event)" @update-form="updateForm($event, 'policy')"></AsuPolicy>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                    <v-expansion-panel-header><strong
                            class="primary--text">Precificação</strong></v-expansion-panel-header>
                    <v-expansion-panel-content>
                    
                        <v-row>
                            <v-col md="2">
                                <v-text-field dense @input="updatePricing()" disabled v-model="form.rules.pricing.currency" label="Moeda" outlined></v-text-field>
                            </v-col>
                            <v-col md="4" cols="12">
                                <v-text-field @input="updatePricing()" dense :persistent-hint="showHint" hint="Valor de tabela"
                                    v-model="form.rules.pricing.tablePrice" label="Preço" outlined>
                                <template v-slot:[`prepend-inner`]>
                                    <span class="pt-1 text-subtitle" v-if="form.rules.pricing.currency == 'BRL'">R$ </span>
                                    <span class="pt-1 text-subtitle" v-else>S/ </span>                                    
                                </template>
                                </v-text-field>
                            </v-col>
                            <v-col md="2" cols="12">
                                <v-text-field @input="updatePricing()" v-model="form.rules.pricing.markup" label="Markup" dense
                                    :persistent-hint="showHint" hint="Adicione a margem apenas se o Valor de tabela for líquido"
                                    outlined></v-text-field>
                            </v-col>
                            <v-col md="4" cols="12">
                                <v-text-field disabled @input="updatePricing()" v-model="form.rules.pricing.unityPrice" label="Preço unitário SEM desconto" dense
                                outlined>
                             <template v-slot:[`prepend-inner`]>
                                    <span class="pt-1 text-subtitle" v-if="form.rules.pricing.currency == 'BRL'">R$ </span>
                                    <span class="pt-1 text-subtitle" v-else>S/ </span>
                                    
                                </template>
                            </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col md="2">
                                <label>Calcular desconto por:</label>
                                <v-switch v-model="discountPercentType" :label="discountPercentType ? 'Percentual' : 'Valor'"></v-switch>
                            </v-col>
                            <v-col md="5">
                                <v-text-field @input="updatePricing()" :disabled="discountPercentType" v-model="form.rules.pricing.discount" label="Desconto" outlined dense
                                    :persistent-hint="showHint"
                                    :hint="!discountPercentType ? 'Desconto padrão em cima do Valor de tabela' : false">
                                 <template v-slot:[`prepend-inner`]>
                                    <span class="pt-1 text-subtitle" v-if="form.rules.pricing.currency == 'BRL'">R$ </span>
                                    <span class="pt-1 text-subtitle" v-else>S/ </span>
                                    
                                </template>
                            </v-text-field>
                            </v-col>
                            <v-col md="5">
                                <v-text-field @input="updatePricing()" :disabled="!discountPercentType" v-model="form.rules.pricing.discountPercent" label="Percentual Desconto" outlined dense
                                :persistent-hint="showHint"
                                :hint="discountPercentType ? 'Percentual de desconto padrão em cima do Valor de tabela' : false">
                                <template v-slot:[`append-inner`]>
                                    <v-icon>mdi-percent-outline</v-icon>
                                    
                                </template>
                            </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col></v-col>
                            <v-col md="5">
                                <v-text-field dense @input="updatePricing()" v-model="form.rules.pricing.price" label="Preço unitário COM desconto"
                                    outlined>
                                 <template v-slot:[`prepend-inner`]>
                                    <span class="pt-1 text-subtitle" v-if="form.rules.pricing.currency == 'BRL'">R$ </span>
                                    <span class="pt-1 text-subtitle" v-else>S/ </span>
                                    
                                </template>
                            </v-text-field>
                            </v-col>
                            <v-col md="5">
                                <v-text-field v-model="form.rules.pricing.label" label="Rótulo complementar" outlined dense
                                    :persistent-hint="showHint"
                                    hint="Desconto padrão em cima do Valor de tabela"></v-text-field>

                            </v-col>
                        </v-row>

                    </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                    <v-expansion-panel-header><strong class="primary--text">Público e
                            audiência</strong></v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <fieldset class="mb-2 pa-3">
                            <legend>Sexo</legend>
                            <p>Participação do público por sexo</p>
                            <div class="d-flex">
                                <v-text-field v-model="form.publicProfile.gender.male" label="Masculino"
                                    outlined></v-text-field>
                                <v-text-field v-model="form.publicProfile.gender.female" label="Feminino"
                                    outlined></v-text-field>
                                <v-btn icons
                                    @click="toRemove('publicProfile', i, 'socialClass')"><v-icon>mdi-close</v-icon></v-btn>
                            </div>
                        </fieldset>

                        <fieldset class="mb-2 pa-3">
                            <legend>Faixa etária</legend>
                            <p>Participação do público por idade</p>
                            <div class="d-flex justify-space-between" v-for="(item, i) in form.publicProfile.ageGroup"
                                :key="i">
                                <v-text-field v-model="form.publicProfile.ageGroup[i].min" number label="Min"
                                    outlined></v-text-field>
                                <v-text-field v-model="form.publicProfile.ageGroup[i].max" number label="Max"
                                    outlined></v-text-field>
                                <v-text-field v-model="form.publicProfile.ageGroup[i].percent" number label="%"
                                    outlined></v-text-field>

                                <v-btn icons
                                    @click="toRemove('publicProfile', i, 'ageGroup')"><v-icon>mdi-close</v-icon></v-btn>
                            </div>
                            <v-btn @click="addItem('publicProfile', { min: 0, max: 0, percent: 0 }, 'ageGroup')">Add
                            </v-btn>
                        </fieldset>
                        <fieldset class="mb-2 pa-3">
                            <legend>Classe social</legend>
                            <p>Participação do público por classe social</p>
                            <div class="d-flex justify-space-between"
                                v-for="(item, i) in form.publicProfile.socialClass" :key="i">
                                <v-text-field v-model="form.publicProfile.socialClass[i].name" number label="Grupo"
                                    outlined></v-text-field>
                                <v-text-field v-model="form.publicProfile.socialClass[i].percent" number label="Valor"
                                    outlined></v-text-field>

                                <v-btn icons
                                    @click="toRemove('publicProfile', i, 'socialClass')"><v-icon>mdi-close</v-icon></v-btn>
                            </div>
                            <v-btn @click="addItem('publicProfile', { name: '', percent: 0 }, 'socialClass')">Add
                            </v-btn>
                        </fieldset>

                        <fieldset class="mb-2 pa-3">
                            <legend>Audiência</legend>
                            <v-text-field v-model="form.audience.label" outlined label="Rótulo"></v-text-field>
                            <v-select :items="['m', 'H', 'D', 'W', 'M']" outlined
                                v-model="form.audience.period"></v-select>
                            <v-text-field v-model="form.audience.value" outlined label="Valor"></v-text-field>
                        </fieldset>
                        <fieldset class="mb-2 pa-3">
                            <legend>Interesses</legend>
                            <div class="d-flex justify-space-between" v-for="(inte, i) in form.interests" :key="i">
                                <v-text-field v-model="form.interests[i]" label="Interesse" outlined></v-text-field>

                                <v-btn icons @click="toRemove('interests', i)"><v-icon>mdi-close</v-icon></v-btn>
                            </div>
                            <v-btn @click="addItem('interests', '')">Add</v-btn>
                        </fieldset>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                    <v-expansion-panel-header><strong
                            class="primary--text">Cobertura</strong></v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <fieldset class="mb-2 pa-3">
                            <legend>Cobertura</legend>
                            <div class="d-flex justify-space-between" v-for="(inte, i) in form.coverage" :key="i">
                                <v-text-field v-model="form.coverage[i]" label="Cobertura" outlined></v-text-field>

                                <v-btn icons @click="toRemove('coverage', i)"><v-icon>mdi-close</v-icon></v-btn>
                            </div>
                            <v-btn @click="addItem('coverage', '')">Add cobertura</v-btn>
                        </fieldset>
                        <fieldset class="mb-2 pa-3">
                            <legend>Localidades
                                <!-- <v-chip v-if="mapChanged" color="yellow darken-2" small class="ml-1">Não
                                    sincronizado</v-chip>
                                <v-chip v-if="!mapChanged" color="green" dark small class="ml-1">Sincronizado <v-icon
                                        small class="ml-1">mdi-check</v-icon></v-chip> -->
                            </legend>
                            <Maps :noUpdate="false" :path="form.sku ? form.sku : this.objectId()"
                                :snap-locations="form.locations" @update-locations="updateLocations($event)"
                                @locations-changed="mapChanged = $event"></Maps>
                        </fieldset>

                    </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                    <v-expansion-panel-header><strong class="primary--text">Galeria de
                            Mídia</strong></v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <fieldset class="mb-2 pa-3">
                            <legend>Imagens</legend>
                            <!-- <div class="d-flex justify-space-between" v-for="(img, i) in form.files" :key="i"> -->
                                <Upload :view="'image'" :path="'/whitelabel-asus/'" @set-upload="updateImages($event)" :snap="files"></Upload>
                                <!-- <v-btn icon @click="toRemove('files', i)"><v-icon>mdi-close</v-icon></v-btn> -->
                            <!-- </div> -->
                            <!-- <v-btn @click="addItem('files', null)">Add image</v-btn> -->
                        </fieldset>
                        <fieldset class="mb-2 pa-3">
                            <legend>Videos</legend>
                            <div class="d-flex justify-space-between" v-for="(vd, v) in form.videos" :key="v">
                                <v-text-field v-model="form.videos[v]" label="Link do Youtube ou Vimeo"
                                    outlined></v-text-field>

                                <v-btn icons @click="toRemove('videos', v)"><v-icon>mdi-close</v-icon></v-btn>
                            </div>
                            <v-btn @click="addItem('videos', '')">Add link de vídeo</v-btn>
                        </fieldset>
                    </v-expansion-panel-content>
                </v-expansion-panel>

                <v-expansion-panel>
                    <v-expansion-panel-header><strong class="primary--text">Configurações de
                            exibição</strong></v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <v-switch v-model="form.home" :persistent-hint="showHint" label="Exibir na home"
                            hint="Exibir entre os formatos na homepage"></v-switch>
                        <v-switch v-model="form.featured" label="Destaque" dense :persistent-hint="showHint"
                            hint="Exibir com destaque na homepage"></v-switch>
                        <v-switch v-model="form.status" :value="'published'" label="Publicado"
                            :persistent-hint="showHint" hint="Ativo ou inativo na loja"></v-switch>

                        <v-switch v-model="form.showInPackOnly" label="Item de pacote" :persistent-hint="showHint"
                            hint="Não vender este formato unitariamente ou fora de um pacote"></v-switch>

                    </v-expansion-panel-content>
                </v-expansion-panel>



            </v-expansion-panels>






        </v-card-text>
        <v-card-actions class="d-flex">
            <v-spacer></v-spacer>
            <v-btn large text @click="cancel.show = true">Cancelar</v-btn>
            <v-btn elevation="0" large @click="save()" color="success">Salvar</v-btn>
        </v-card-actions>
        <v-dialog v-model="cancel.show" max-width="480">
            <v-card>
                <v-card-title>Seu preenchimento não foi salvo!</v-card-title>
                <v-card-text>
                    Tem certeza que deseja cancelar as alterações não salvas?
                </v-card-text>
                <v-card-actions>
                    <div class="d-flex" style="width: 100%">
                        <v-spacer></v-spacer>
                        <v-btn text @click="cancel.show = false" class="mx-1">Continuar editando</v-btn>
                        <v-btn color="error" @click="$emit('close-form')" elevation="0">Confirmar</v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>

</template>
<script>
import moment from 'moment-timezone'
import { getFirestore, doc, setDoc, collection, query, where, getDocs, GeoPoint } from "firebase/firestore";
import Upload from '../../interface/FileUpload.vue';
import Maps from './MapModule.vue'
import AsuInfo from './Modules/AsuInfo.vue'
import AsuPolicy from './Modules/AsuPolicy.vue'
export default {
    components: { Upload, Maps, AsuInfo, AsuPolicy },
    watch: {
        // 'form.rules.pricing': {
        //     deep: true,
        //     handler(v) {


        //         if (v.tablePrice && v.markup) {
        //             this.form.rules.pricing.unityPrice = v.tablePrice * v.markup
        //         }

        //         this.form.rules.pricing.price = parseFloat(v.unityPrice) - parseFloat(v.discount)
        //         if(this.discountPercentType){
        //             this.form.rules.pricing.discountPercent =  this.form.rules.pricing.price / (this.form.rules.pricing.discount * 100)
        //         }
        //         else{
        //             this.form.rules.pricing.discount = this.form.rules.pricing.discountPercent > 0 ? this.form.rules.pricing.price * (this.form.rules.pricing.discountPercent / 100) : this.form.rules.pricing.price 
        //         }
        //     }
        // },
        
        // 'show': {
        //     handler(v){
        //         if(!v)
        //         this.form = JSON.parse(JSON.stringify(this.model))
        //     }
        // }
    },
    props: {
        editing: Boolean,
        asu: Object,
        stores: Array
    },
    data() {
        return {
            discountPercentType: false,
            models: {
                info: {
                    'title': "Informações",
                    'ok': 0,
                    'total': 8
                },
                policy: {
                    'title': "Política de compra",
                    'ok': 0,
                    'total': 10
                },
            },

            cancel: {
                show: false
            },
            showHint: true,
            panel: [],
            search: "",
            mapChanged: false,
            weekDays: [
                { v: 0, t: 'Dom' },
                { v: 1, t: 'Seg' },
                { v: 2, t: 'Ter' },
                { v: 3, t: 'Qua' },
                { v: 4, t: 'Qui' },
                { v: 5, t: 'Sex' },
                { v: 6, t: 'Sab' },
            ],
            formulas: ["PI", "PQ", "PQI"],
            snap: null,
            show: false,
            model: {
                rules: {
                    formula: "",
                    insertions: { "min": null, "max": null, options: [] },
                    quantity: { "min": null, "max": null, options: [] },
                    periodicity: { type: "", value: null },
                    periods: { min: null, max: null },
                    pricing: {
                        currency: "BRL",
                        discount: null,
                        discountPercent: null,
                        markup: 1,
                        price: 0,
                        tablePrice: 0,
                        unityPrice: 0,
                        label: ""

                    },
                    publishDays: [0, 1, 2, 3, 4, 5, 6],
                    reservation: { min: null, max: null },
                    weekDays: [0, 1, 2, 3, 4, 5, 6]

                },
                audience: {
                    label: "",
                    period: "",
                    value: 0
                },
                format: {
                    metric: "",
                    print: "",
                    type: "",
                    value: ""
                },
                internalCode: "",
                videos: [],
                buckets: [],
                category: "",
                featured: "",
                home: "",
                description: "",
                advantage: "",
                specifications: "",
                specificationTypes: [],
                files: [],
                interests: [],
                locations: [],
                coverage: [],
                mediaType: {
                    parents: "",
                    category: ""
                },
                publicProfile: {
                    ageGroup: [],
                    socialClass: [],
                    gender: {
                        male: 0,
                        female: 0
                    }
                },
                showInPackOnly: false,
                status: 'published',
                store: "",
                sku: "",
            },
            form: {
                rules: {
                    formula: "",
                    insertions: { "min": null, "max": null, options: [] },
                    quantity: { "min": null, "max": null, options: [] },
                    periodicity: { type: "", value: null },
                    periods: { min: null, max: null },
                    pricing: {
                        currency: "BRL",
                        discount: null,
                        discountPercent: null,
                        markup: 1,
                        price: 0,
                        tablePrice: 0,
                        unityPrice: 0,
                        label: ""

                    },
                    publishDays: [0, 1, 2, 3, 4, 5, 6],
                    reservation: { min: null, max: null },
                    weekDays: [0, 1, 2, 3, 4, 5, 6]

                },
                internalCode: "",
                videos: [],
                audience: {
                    label: "",
                    period: "",
                    value: 0
                },
                format: {
                    metric: "",
                    print: "",
                    type: "",
                    value: ""
                },
                buckets: [],
                category: "",
                featured: "",
                home: "",
                description: "",
                advantage: "",
                specifications: "",
                specificationTypes: [],
                files: [],
                interests: [],
                locations: [],
                coverage: [],
                mediaType: {
                    parents: "",
                    category: ""
                },
                publicProfile: {
                    ageGroup: [],
                    socialClass: [],
                    gender: {
                        male: 0,
                        female: 0
                    }
                },
                showInPackOnly: false,
                status: 'published',
                store: "",
                sku: "",

            },
            headers: [
                {

                    text: "SKU",
                    align: "start",
                    sortable: false,
                    value: "sku",
                }, {
                    text: "Formato",
                    align: "start",
                    sortable: false,
                    value: "_format",
                }, {
                    text: "Cobertura",
                    align: "start",
                    sortable: false,
                    value: "_coverage"
                },
                {
                    text: "Store",
                    align: "start",
                    sortable: false,
                    value: "store",
                },
                , {
                    text: "Criado em",
                    align: "start",
                    sortable: false,
                    value: "createdOn",
                }
                , {
                    text: "Atualizado em",
                    align: "start",
                    sortable: false,
                    value: "updatedOn",
                },
                { text: "Status", align: "center", value: "status" },
                { text: "", value: "actions", sortable: false }
            ],
            desserts: [],
        };
    },
    computed: {
        files(){
            const res = []
            const files = this.form.files
            files.forEach((file) => {
                if(typeof file == 'string')
                res.push({url: file})
            else
            res.push(file)
            })
            return res
        },
        cssProps() {
            return {
                '--secondary-color': this.$vuetify.theme.secondary
            }
        },
        // stores() {
        //     return Object.values(this.$root.stores)
        // },
        allCoverages() {
            const res = []
            this.desserts.forEach((d) => {
                if (!d.hasOwnProperty('coverage'))
                    d.coverage = []
                d.coverage.forEach((c) => {
                    if (!res.includes(c))
                        res.push(c)
                })
            })
            return res
        }
    },
    mounted() {
        if (this.editing) {
            this.form.sku = this.asu.sku
            if(this.$route.fullPath != `/products/asus?action=edit&id=${this.asu.sku}`)
            this.$router.push(`/products/asus?action=edit&id=${this.asu.sku}`)

            const item = this.asu
            if (!item.hasOwnProperty('videos')) {
                item.videos = []
            }
            if (!item.hasOwnProperty('internalCode')) {
                item.internalCode = ""
            }
            if (!item.rules.pricing.hasOwnProperty('discountPercent')) {
                item.rules.pricing.discountPercent = 0
            }
            if (!item.rules.pricing.hasOwnProperty('label')) {
                item.rules.pricing.label = ""
            }
            this.snap = item
            this.form = item
        }
        else {
            if($this.$route.fullPath != "/products/asus?action=new")
            this.$router.push("/products/asus?action=new")
            this.form = JSON.parse(JSON.stringify(this.model))
            this.snap = JSON.parse(JSON.stringify(this.model))
        }
    },
    methods: {
        updatePricing(){
            const v = this.form.rules.pricing
            setTimeout(() => {
                if(this.form.rules.pricing.discount == '')
                this.form.rules.pricing.discount = 0
                if(this.form.rules.pricing.discountPercent == '')
                this.form.rules.pricing.discountPercent = 0
                if (v.tablePrice && v.markup) {
                        this.form.rules.pricing.unityPrice = v.tablePrice * v.markup
                    }
                    
                    if(this.discountPercentType){
                        this.form.rules.pricing.discount = this.form.rules.pricing.discountPercent > 0 ? this.form.rules.pricing.unityPrice * (this.form.rules.pricing.discountPercent / 100) : this.form.rules.pricing.unityPrice 
                    }
                    else{
                        this.form.rules.pricing.discountPercent =  this.form.rules.pricing.discount && this.form.rules.pricing.discount > 0 ? this.form.rules.pricing.unityPrice / (this.form.rules.pricing.discount) : 0
                    }
                    this.form.rules.pricing.price = parseFloat(v.unityPrice) - parseFloat(v.discount)

            },100)
        },
        updateImages(e){
            console.log('e', e)
            const f = e.map(i => i.url)
            console.log('F', f)
            this.form.files = f
        },
        updateForm(e, block){
            const form = JSON.parse(JSON.stringify(this.form))
            if(!form.hasOwnProperty('specificationTypes'))
                form.specificationTypes = []
            let keys = []
            if(block == 'info'){
                keys = ['store', 'mediaType', 'format', 'buckets', 'description', 'advantage', 'specifications', 'category', 'internalCode', 'specificationTypes']
                keys.forEach((k) => {
                    form[k] = e[k]
                })
                const _format = form.format
                form._format = _format.print.replace('type', _format.type).replace('metric', _format.metric).replace('value', _format.value)
            }
             if(block == 'policy'){
                keys = ['rules']
                keys.forEach((k) => {
                    form[k] = e[k]
                })

            }
            console.log('Fo r M', form)
            this.form = form
        },
        updateMod(k, e) {
            console.log('K K K K', k)
            console.log('E E E E', e)
            this.models[k] = e
        },
        copyMe(value) {
            navigator.clipboard.writeText(value);
            alert('SKU copiada com sucesso.')
        },
        formatDate(d) {
            console.log('D', d)
            return moment(d).format('DD/MM/YYYY HH:mm')
        },
        addImage() {
            this.form.files.push('image')
        },
        addItem(k, v, l = null) {
            if (l)
                this.form[k][l].push(v)
            else
                this.form[k].push(v)
        },
        toRemove(k, index, l = null) {
            if (l) {
                this.form[k][l].splice(index, 1)
            }
            else {
                this.form[k].splice(index, 1)
            }
        },
        duplicate(item) {
            const Form = JSON.parse(JSON.stringify(item))
            Form.copyFrom = item.id
            Form.createdOn = moment().format()
            Form.updatedOn = moment().format()
            Form.sku = this.objectId()
            Form.audience.value = parseFloat(Form.audience.value)
            Form.publicProfile.ageGroup.forEach((p) => {
                p.percent = parseFloat(p.percent)
            })
            Form.publicProfile.gender.male = parseFloat(Form.publicProfile.gender.male)
            Form.publicProfile.gender.female = parseFloat(Form.publicProfile.gender.female)

            Form.publicProfile.socialClass.forEach((p) => {
                p.percent = parseFloat(p.percent)
            })
            Form.rules.periodicity.value = Form.rules.periodicity.value && isNaN(Form.rules.periodicity.value) ? parseFloat(Form.rules.periodicity.value.replace(',', '.')) : Form.rules.periodicity.value
            Form.rules.periods.min = Form.rules.periods.min && isNaN(Form.rules.periods.min) ? parseFloat(Form.rules.periods.min.replace(',', '.')) : Form.rules.periods.min
            Form.rules.periods.max = Form.rules.periods.max && isNaN(Form.rules.periods.max) ? parseFloat(Form.rules.periods.max.replace(',', '.')) : Form.rules.periods.max
            Form.rules.quantity.min = Form.rules.quantity.min && isNaN(Form.rules.quantity.min) ? parseFloat(Form.rules.quantity.min.replace(',', '.')) : Form.rules.quantity.min
            Form.rules.quantity.max = Form.rules.quantity.max && isNaN(Form.rules.quantity.max) ? parseFloat(Form.rules.quantity.max.replace(',', '.')) : Form.rules.quantity.max
            Form.rules.reservation.min = Form.rules.reservation.min && isNaN(Form.rules.reservation.min) ? parseFloat(Form.rules.reservation.min.replace(',', '.')) : Form.rules.reservation.min
            Form.rules.reservation.max = Form.rules.reservation.max && isNaN(Form.rules.reservation.max) ? parseFloat(Form.rules.reservation.max.replace(',', '.')) : Form.rules.reservation.max
            Form.rules.pricing.discountPercent = Form.rules.pricing.discountPercent && isNaN(Form.rules.pricing.discountPercent) ? parseFloat(Form.rules.pricing.discountPercent.replace(',', '.')) : Form.rules.pricing.discountPercent
            Form.rules.pricing.discount = Form.rules.pricing.discount && isNaN(Form.rules.pricing.discount) ? parseFloat(Form.rules.pricing.discount.replace(',', '.')) : Form.rules.pricing.discount
            Form.rules.pricing.tablePrice = Form.rules.pricing.tablePrice && isNaN(Form.rules.pricing.tablePrice) ? parseFloat(Form.rules.pricing.tablePrice.replace(',', '.')) : Form.rules.pricing.tablePrice
            Form.rules.pricing.unityPrice = Form.rules.pricing.unityPrice && isNaN(Form.rules.pricing.unityPrice) ? parseFloat(Form.rules.pricing.unityPrice.replace(',', '.')) : Form.rules.pricing.unityPrice

            const db = getFirestore(this.$firebase)
            setDoc(doc(db, "asus", Form.sku), Form).then(() => {

                this.editItem(Form)
                this.loadSlides()
            });
        },
        save() {
            const Form = this.form
            Form.createdOn = this.form.sku ? this.form.createdOn : moment().format()
            Form.updatedOn = moment().format()
            Form.sku = this.form.sku && this.editing ? this.form.sku : this.objectId()
            Form.audience.value = parseFloat(Form.audience.value)
            Form.publicProfile.ageGroup.forEach((p) => {
                p.percent = parseFloat(p.percent)
            })
            Form.publicProfile.gender.male = parseFloat(Form.publicProfile.gender.male)
            Form.publicProfile.gender.female = parseFloat(Form.publicProfile.gender.female)

            Form.publicProfile.socialClass.forEach((p) => {
                p.percent = parseFloat(p.percent)
            })

            Form.rules.periodicity.value = Form.rules.periodicity.value && isNaN(Form.rules.periodicity.value) ? parseFloat(Form.rules.periodicity.value.replace(',', '.')) : Form.rules.periodicity.value
            Form.rules.periods.min = Form.rules.periods.min && isNaN(Form.rules.periods.min) ? parseFloat(Form.rules.periods.min.replace(',', '.')) : Form.rules.periods.min
            Form.rules.periods.max = Form.rules.periods.max && isNaN(Form.rules.periods.max) ? parseFloat(Form.rules.periods.max.replace(',', '.')) : Form.rules.periods.max
            Form.rules.quantity.min = Form.rules.quantity.min && isNaN(Form.rules.quantity.min) ? parseFloat(Form.rules.quantity.min.replace(',', '.')) : Form.rules.quantity.min
            Form.rules.quantity.max = Form.rules.quantity.max && isNaN(Form.rules.quantity.max) ? parseFloat(Form.rules.quantity.max.replace(',', '.')) : Form.rules.quantity.max
            Form.rules.reservation.min = Form.rules.reservation.min && isNaN(Form.rules.reservation.min) ? parseFloat(Form.rules.reservation.min.replace(',', '.')) : Form.rules.reservation.min
            Form.rules.reservation.max = Form.rules.reservation.max && isNaN(Form.rules.reservation.max) ? parseFloat(Form.rules.reservation.max.replace(',', '.')) : Form.rules.reservation.max

            Form.rules.pricing.discount = Form.rules.pricing.discount && isNaN(Form.rules.pricing.discount) ? parseFloat(Form.rules.pricing.discount.replace(',', '.')) : Form.rules.pricing.discount
            Form.rules.pricing.tablePrice = Form.rules.pricing.tablePrice && isNaN(Form.rules.pricing.tablePrice) ? parseFloat(Form.rules.pricing.tablePrice.replace(',', '.')) : Form.rules.pricing.tablePrice
            Form.rules.pricing.unityPrice = Form.rules.pricing.unityPrice && isNaN(Form.rules.pricing.unityPrice) ? parseFloat(Form.rules.pricing.unityPrice.replace(',', '.')) : Form.rules.pricing.unityPrice

            console.log('Form', Form)
            const db = getFirestore(this.$firebase)
            setDoc(doc(db, "asus", Form.sku), Form).then(() => {
                this.$emit('update-asu', Form)
            });
        },
        objectId() {
            var timestamp = (new Date().getTime() / 1000 | 0).toString(16);
            return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => {
                return (Math.random() * 16 | 0).toString(16);
            }).toLowerCase();
        },
        loadSlides() {
            const db = getFirestore(this.$firebase);
            const q = query(collection(db, "asus"));
            const querySnapshot = getDocs(q);
            const asus = []
            querySnapshot.then((docs) => {
                docs.forEach((doc) => {
                    // format
                    const format = doc.data()
                    format.id = doc.id
                    if (!format.hasOwnProperty('coverage')) {
                        format.coverage = []
                    }
                    let fm = format.format
                    format._format = fm.print.replace('type', fm.type).replace('metric', fm.metric).replace('value', fm.value)
                    asus.push(format)
                    format._coverage = format.coverage.join(', ')
                })
                this.desserts = asus

            })
        },
        updateLocations(e) {
            this.form.locations = e.locations
            this.form.mapImage = e.mapImage
        }
    }
}
</script>
<style lang="scss">
/*.--custom-panels{
    .v-expansion-panel{
        background: #f7f7f7;
        margin-bottom: 10px;
        border: 2px solid #203a75aa;
        border-radius: 5px;
    }
}
    */
.-asu-form {

    .v-text-field__details {
        overflow: visible !important;

        .v-messages__message {

            color: #000;
            width: fit-content;
            padding: 3px 6px;
            position: relative;
            background: #ffe0bf;
            border: 1px solid #ff9800;
            border-radius: 3px;
            box-shadow: 0 1px 3px rgba(0, 0, 0, .1);

            &:after,
            &:before {
                bottom: 100%;
                left: 50%;
                border: solid transparent;
                content: "";
                height: 0;
                width: 0;
                position: absolute;
                pointer-events: none;
            }

            &:after {
                border-color: rgba(186, 175, 74, 0);
                border-bottom-color: #ffe0bf;
                border-width: 5px;
                margin-left: -5px;
            }

            &:before {
                border-color: rgba(186, 175, 74, 0);
                border-bottom-color: #ff9800;
                border-width: 6px;
                margin-left: -6px;
            }
        }
    }
    .-input-success .v-text-field__details .v-messages__message {
        color: #4caf50;
        background: #d2f0d3;
        border-color: #4caf50;
        &:after {
            border-bottom-color: #d2f0d3;
        }
        &:before {
            border-bottom-color: #4caf50;
        }
    }
    .-input-neutral .v-text-field__details .v-messages__message {
        color: #2196f3;
        background: #e6f2fd;
        border-color: #2196f399;
        &:after {
            border-bottom-color: #e6f2fd;
        }
        &:before {
            border-bottom-color: #2196f399;
        }
    }
}
</style>